<div class="transfer-container w-100">
  <div>
    <img
      src="/assets/images/main-plan-card/transferToUs.jpeg"
      alt="transfer to us"
      class="w-100 transfer-img"
    />
  </div>
  <div class="d-flex justify-content-center flex-column text-center align-items-center px-4 pt-4">
    <h4>Transfer To Us:</h4>
    <p class="text-center">
      If you have pets registered on any other database or overseas, identialert allows you to
      transfer all your pets together with no extra cost. Simply contact our Pet Protection Experts
      and they will talk you through the process
    </p>

    <button
      class="btn btn-outline-dark btn-lg btn-learn-more"
      type="button"
      routerLink="/contact-us"
    >
      Call Us
    </button>
  </div>
</div>
